module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<% var i18n = require(\'@cdo/locale\'); %>\n<div class="function-name">\n  <% if (signatureOverride) { -%>\n    <%= signatureOverride %>\n  <% } else {\n    /**\n     * TODO(bjordan): would be nice to split the following line up, can\'t figure\n     * out how to do so without inserting extraneous spaces between parameters.\n     */\n    -%>\n    <%= functionName %>(<% for (var i = 0; i < parameters.length; i++) { -%><span class="tooltip-parameter-name <% if (i === currentParameterIndex) { %> current-tooltip-parameter-name<% } %>"><%- parameters[i].name -%></span><% if (i < parameters.length - 1) { -%>, <% } -%><% } -%>)\n  <% } %>\n</div>\n<% if (parameters[currentParameterIndex] && parameters[currentParameterIndex].description) { %><div><%= parameters[currentParameterIndex].description %></div><% } %>\n<% if (parameters[currentParameterIndex] && parameters[currentParameterIndex].assetTooltip) { %>\n  <div class="tooltip-choose-link">\n    <a href="#"><%= i18n.choosePrefix() %></a>\n  </div>\n<% } %>\n<% if (showExamplesLink) { %>\n  <div class="tooltip-example-link">\n    <a href="#"><%= i18n.examples() %></a>\n  </div>\n<% } %>\n', __filename = "src/blockTooltips/DropletParameterTooltip.html.ejs";
    try {
        var __output = [], __append = __output.push.bind(__output);
        with (locals || {}) {
            var i18n = require("@cdo/locale");
            __append('\n<div class="function-name">\n  ');
            __line = 3;
            if (signatureOverride) {
                __append("    ");
                __line = 4;
                __append(escapeFn(signatureOverride));
                __append("\n  ");
                __line = 5;
            } else {
                __line = 10;
                __append("    ");
                __line = 11;
                __append(escapeFn(functionName));
                __append("(");
                for (var i = 0; i < parameters.length; i++) {
                    __append('<span class="tooltip-parameter-name ');
                    if (i === currentParameterIndex) {
                        __append(" current-tooltip-parameter-name");
                    }
                    __append('">');
                    __append(parameters[i].name);
                    __append("</span>");
                    if (i < parameters.length - 1) {
                        __append(", ");
                    }
                }
                __append(")\n  ");
                __line = 12;
            }
            __append("\n</div>\n");
            __line = 14;
            if (parameters[currentParameterIndex] && parameters[currentParameterIndex].description) {
                __append("<div>");
                __append(escapeFn(parameters[currentParameterIndex].description));
                __append("</div>");
            }
            __append("\n");
            __line = 15;
            if (parameters[currentParameterIndex] && parameters[currentParameterIndex].assetTooltip) {
                __append('\n  <div class="tooltip-choose-link">\n    <a href="#">');
                __line = 17;
                __append(escapeFn(i18n.choosePrefix()));
                __append("</a>\n  </div>\n");
                __line = 19;
            }
            __append("\n");
            __line = 20;
            if (showExamplesLink) {
                __append('\n  <div class="tooltip-example-link">\n    <a href="#">');
                __line = 22;
                __append(escapeFn(i18n.examples()));
                __append("</a>\n  </div>\n");
                __line = 24;
            }
            __append("\n");
            __line = 25;
        }
        return __output.join("");
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}